module.exports = __webpack_public_path__ + "img/course-title-icon.58d77683.svg";